import request from '@/request'
import handler from '@/utils/responseHandler'

function requestTicket(data) {
  return request.ticket({
    url: '/gateway/gtgj/act2',
    auth: 'yes',
    data,
    sidFields: ['uid', 'pid']
  }).then(handler.resBdData)
}

export default {
  /**
   * 红包列表
   */
  335501: (data = {}) => {
    data.pid = 335501
    return requestTicket(data)
  }
}



// WEBPACK FOOTER //
// ./src/api/coupons.js